import { IFinanceCalculatorState } from "../../../../models/finance-calculator.model";
import { formatCurrency, formatNumber } from "../../../shared/utils";

const FinanceCalculatorFormSummary = ({ state }: { state: IFinanceCalculatorState }) => {
    const getCaveatText = () => {
        return "This quote is an example only. The exact figures and rate will be based on your circumstances.";
    }

    const getCreditRatingText = () => {
        // return "Based on a customer with " + (state.formdata.creditRating === "excellent" ? "an" : "a ") + state.formdata.creditRating + " credit rating.";
        return getCaveatText();
    }

    const getFinanceText = () => {
        let r = "Showing ";
        if (state.formdata.showHP && state.formdata.showPCP) {
            r = r + "HP & PCP";
        } else {
            if (state.formdata.showHP) {
                r = r + "HP";
            } else {
                r = r + "PCP"
            }
        }
        r = r + " finance of " + formatCurrency(((state.formdata.cashPrice || 0) - state.formdata.deposit));
        r = r + " over " + state.formdata.term + " months";
        r = r + ".";
        return r;
    };
    
    const getVehicleText = () => {
        let r = "";
        if (!state.formdata.knownRegNo && state.formdata.identity) {
            r = r + "Vehicle: " + state.formdata.identity.vehicleDesc;
        } else {
            r = r + "Vehicle: " + state.formdata.regNo.toLocaleUpperCase();
        }
        r = r + ", Current mileage: " + formatNumber(state.formdata.currentMileage);
        if (state.formdata.showPCP) {
            r = r + ", Anticipated annual mileage: " + formatNumber(state.formdata.annualMileage);
        }
        r = r + ".";
        return r;
    };
    
  return (
  <>
      { false && (
         <div>{getFinanceText()}</div>
      )}
      { state.formdata.vehicleBased && (state.formdata.regNo || state.formdata.identity) &&
        (<div>{getVehicleText()}</div>)
      }
      <div>{getCreditRatingText()}</div>
      <br/>
  </>
  ); 
};

export default FinanceCalculatorFormSummary;
